var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_4739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4355 3.46708C26.1244 2.29857 25.2108 1.38029 24.0484 1.0675C21.9437 0.5 13.5 0.5 13.5 0.5C13.5 0.5 5.0564 0.5 2.9516 1.0675C1.78919 1.38029 0.875703 2.29857 0.564539 3.46708C1.68988e-07 5.5829 0 10 0 10C0 10 1.68988e-07 14.4171 0.564539 16.533C0.875703 17.7015 1.78919 18.6197 2.9516 18.9325C5.0564 19.5 13.5 19.5 13.5 19.5C13.5 19.5 21.9437 19.5 24.0484 18.9325C25.2108 18.6197 26.1244 17.7015 26.4355 16.533C27.0001 14.4171 27.0001 10 27.0001 10C27.0001 10 26.9978 5.5829 26.4355 3.46708Z",
    fill: "#FF5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7969 14.0713L17.8114 10.0005L10.7969 5.92969V14.0713Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_4739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 19,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "b53a1b28e0b5cda639b90a7e0ba0659d.svg";
export { ForwardRef as ReactComponent };